import Nullstack from 'nullstack';
export default function IconGasStation({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-gas-station",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M14 11h1a2 2 0 0 1 2 2v3a1.5 1.5 0 0 0 3 0v-7l-3 -3"
  }), "   ", Nullstack.element("path", {
    d: "M4 20v-14a2 2 0 0 1 2 -2h6a2 2 0 0 1 2 2v14"
  }), "   ", Nullstack.element("line", {
    x1: "3",
    y1: "20",
    x2: "15",
    y2: "20"
  }), "   ", Nullstack.element("path", {
    d: "M18 7v1a1 1 0 0 0 1 1h1"
  }), "   ", Nullstack.element("line", {
    x1: "4",
    y1: "11",
    x2: "14",
    y2: "11"
  }), " ");
}